import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["stroke"]
const _hoisted_3 = ["stroke"]
const _hoisted_4 = ["stroke"]
const _hoisted_5 = ["fill"]
const _hoisted_6 = ["fill"]


export default /*@__PURE__*/_defineComponent({
  __name: 'skiSvgIcon',
  props: {
    color: {},
    width: {},
    height: {},
    fill: {},
    stroke: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: _ctx.width,
    height: _ctx.height,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("path", {
      d: "M2.28955 6.72662L17.7743 9.89399",
      stroke: _ctx.stroke,
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round"
    }, null, 8, _hoisted_2),
    _createElementVNode("path", {
      d: "M3.89804 5.8291L3.32324 8.2443",
      stroke: _ctx.stroke,
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round"
    }, null, 8, _hoisted_3),
    _createElementVNode("path", {
      d: "M1.4668 11.8024L14.163 18.2985C15.0525 18.7506 16.1354 18.5359 16.7862 17.7784L17.5797 16.8556",
      stroke: _ctx.stroke,
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round"
    }, null, 8, _hoisted_4),
    _createElementVNode("path", {
      d: "M16.9114 4.51811C17.8829 4.51811 18.6705 3.73056 18.6705 2.75906C18.6705 1.78756 17.8829 1 16.9114 1C15.9399 1 15.1523 1.78756 15.1523 2.75906C15.1523 3.73056 15.9399 4.51811 16.9114 4.51811Z",
      fill: _ctx.fill
    }, null, 8, _hoisted_5),
    _createElementVNode("path", {
      d: "M14.6683 5.08755C14.2615 4.12733 13.1533 3.67923 12.1931 4.08599L8.63096 5.59566C7.72809 5.97841 7.27866 6.9813 7.56672 7.8975C7.59873 8.03087 7.65474 8.1589 7.73476 8.27759C7.81344 8.41495 7.90813 8.54031 8.01482 8.64967L10.2313 11.5583L7.44536 12.6732C6.84389 12.9133 6.55183 13.5961 6.79322 14.1962C6.97592 14.655 7.41602 14.9337 7.88146 14.9337C8.02682 14.9337 8.17352 14.9071 8.31622 14.8497L12.5638 13.1507C12.9079 13.0133 13.1666 12.7212 13.2613 12.3625C13.356 12.0051 13.276 11.6223 13.0453 11.3329L11.0075 8.68968L13.6681 7.56143C14.6283 7.15467 15.0764 6.04643 14.6696 5.08621L14.6683 5.08755Z",
      fill: _ctx.fill
    }, null, 8, _hoisted_6)
  ], 8, _hoisted_1))
}
}

})